module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00679.84002d0b.jpg";